//produccion
const base="https://apps.eshopex.cl/serviciosresteshopex/"

//desarrollo
//const base="http://localhost:53292/"

export const cuentaCliente=
{
    DatosClientes:base+"api/cliente/getByRut/@rut",
    BorrarCuenta:base+"api/cliente/deleteCuenta/@ecode",
    ModificarCuenta:base+"api/cliente/ModificarCuenta",
    CrearCuenta:base+"api/cliente/Crearcuenta",
    ModificarContrasena:base+"api/cliente/ModificarContrasena",
    VerificarContrasena:base+"api/ClienteS/Verificar",
    ApiZoom:base+"api/cliente/zoom/@ecode",
    CrearEspana:base+"api/casilla/espana/Crear/@ecode/@rut",
    EliminarEspana:base+"api/casilla/espana/Eliminacion/@ecode/@rut",
    ActualizarPreferencia:base+"/api/cliente/actualizar",
    Regiones:base+"api/cliente/Regiones",
    Comunas:base+"api/cliente/comuna/@idregion",
    EliminarPreferencia:base+"api/cliente/EliminacionPrefencia",
    DatosFacturacion:base+"api/cliente/ActualizarFacturacion",
    SubirImagen:base+"api/cliente/ImagenS3",
    PreAlerta:base+"api/cliente/Alerta/",
    SubirImagenFactura:base+"api/cliente/ImagenS3SubirFacturas",
    SubirFactura:base+"api/cliente/InsertSinFactura",
    InicioGoogle:base+"api/ClienteS/InicioGoggle/@email/",
    VerificacionGoogle:base+"api/ClienteS/MaximoGoogle/",
    AumentoGoogle:base+"api/ClienteS/AumentoGoogle/",
    ValidacionRegistro:base+"api/cliente/ValidacionRegistro/@rut",
    ValidacionRut:base+"api/cliente/ValidacionCliente/",
    Registro:base+"api/cliente/RegistroCliente/",
    RegistroGoogle:base+"api/cliente/RegistroClienteGoogle/",
    HistorialPuntosRewards:base+"api/Cliente/VerPuntosRewards/@ecode",
    PuntosPorVencer:base+"api/Cliente/PorVencer/@ecode",
    HistorialAmigoReferidos:base+"api/Cliente/AmigoReferidoVisual/@ecode",
    RecuperarContrasena:base+"api/ClienteS/RecuperarContrasena/@email/",
    RestablecerContrasena:base+"api/ClienteS/RestablecerContrasena/",
    CierreCuenta:base+"api/cliente/CierreCuenta/"
}

export const Carga=
{
    ObtenerCargas:base+"api/Cargas/GetByRutEcode/@rutcli/@ecode/@estado",
    ModificarCarga:base+"api/Cargas/",
    SolicitarTraslado:base+"api/Cargas/solicitarTraslado",
    RastreoCarga:base+"api/Cargas/RastreoCarga/@ecode/@guiahija",
    Historial:base+"api/Cargas/Historial/@ecode/@guiahija/@fechaIni/@FechaFin",
    Notificaciones:base+"api/Cargas/Notificaciones/@ecode/@rut",
    Retiro:base+"api/Cargas/Retiro/@ecode/@guiahija",
    Busqueda:base+"api/Cargas/busqueda/@ecode/@guia/@rut",
    BusquedaFecha:base+"api/Cargas/BusquedaFecha/",
    Calculadora:base+"api/ClienteS/Calculadora/",
    Sucursal:base+"api/ClienteS/Atencion",
    SucursalesBusqueda:base+"api/ClienteS/Regiones/@idRegion",
    SinFactura:base+"api/Cargas/factura/@ecode/@rut/@guiahija",
    RastreoPreAlertas:base+"api/Cargas/PreAlerta/@ecode",
    DetalleCupon:base+"api/cliente/TraerCupon/@cupon",
    TodosCupones:base+"api/cliente/TraerTodosCupon/@rut",
    RevisarDatos:base+"api/Cargas/TraerGuiasPendientes/@ecode",
    ConfirmarGuias:base+"api/Cargas/TraerGuias/@guia",
    SubirDocumentos:base+"api/Cargas/SubirDocumentos/",
    DescuentoConvenio:base+"api/cliente/TraerDescuento/@ecode",
    DetalleConvenio:base+"api/cliente/DetalleDescuento/@cupon",
    TraerBase64:base+"api/Cargas/Base64/@id_doc"
}


export const AmigoReferid=
{
    ValidacionEmpresa:base+"api/Amigo/validacion/@ecode",
    ValidacionCorreo:base+"api/Amigo/validacionCorreo",
    EnviarNotificaciones:base+"api/Amigo/Notificacione",
    RevisionReferidor:base+"api/Amigo/VerificacionCasillaReferidor/@ecode",
    CrearReferidor:base+"api/Amigo/CrearReferidor/@ecode",
    ActualizarDatos:base+"api/Amigo/ActualizarDatos",
    CargandoPuntos:base+"api/Amigo/CargandoPuntos",
    ValidadId:base+"api/Amigo/VerificarIdAmigoReferido/@id"
}   

export const Pagos=
{
    ConsultarPago:base+"api/Pago/Montos",
    Reglas:base+"api/Pago/Reglas/@id",
    TraeConvenios:base+"api/Pago/traerConvenios",
    Verificacion:base+"api/Pago/Verificar",
    MaximoRewards:base+"api/Pago/MaxRewards",
    PagoWebpay:base+"api/Pago/PagoWebpay/@batch",
    RetornoWebpay:base+"api/Pago/RetornoWebpay/@batch",
    UrlWebpay:"https://webpay3gint.transbank.cl/webpayserver/initTransaction",
    PagoPaypal:base+"api/Pago/PagoPaypal/@batch",
    RetornoPaypal:base+"api/Pago/PagoPaypalRetorno/@batch",
    PagoPendientes:base+"api/Pago/PagoPendiente/@ecode/@guiahija",
    //url pago despachos
    despacho:"https://apps.eshopex.cl/despachos/delivery2.aspx?id=@@awb&id2=@ecode&xselection=1",
    prepago:"https://apps.eshopex.cl/despachos/prepago.aspx?id=@@awb&id2=@ecode&xselection=1",
    retiro:"https://apps.eshopex.cl/despachos/retirooficina.aspx?id=@@awb&id2=@ecode&xselection=",
    PAgoPreAlertas:"https://apps.eshopex.cl/despachos/PreAlerta.aspx?id=@@awb&id2=@ecode&xselection=1"

}
export const VendemosContigo=
{
    TraerGuiasSin:base+"api/VendemosContigo/TraerGuiasSin/@ecode/",
    TraerGuiasCon:base+"api/VendemosContigo/TraerGuiasCon/@ecode/",
    ActualizarSin:base+"api/VendemosContigo/ActualizarSin/",
    ActualizarCon:base+"api/VendemosContigo/ActualizarCon/",
    Eliminacion:base+"api/VendemosContigo/EliminacionPreAlerta/@id/",
    EditarPreAlerta:base+"api/VendemosContigo/EditarPreAlerta/"
}
export const Toke=
{
    tokes:base+"token"
}
export const Redireccion=
{

    //desarrollo

    //login:"http://localhost:3000/login",
    //datosExtraGoogle:"http://localhost:3000/solicitud",

    //produccion
    login:"https://cuenta.eshopex.cl/login",
    datosExtraGoogle:"https://cuenta.eshopex.cl/solicitud",

    UrlAmigoReferido:"https://eshopex.cl/registro?ecode="
}